import { REWARD_OFFERING } from "../constants";
import CompetitionPage from "../common/components/CompetitionPage";

function WeekTwoMain() {
  const offerId = REWARD_OFFERING.weektwo;

  return (
    <CompetitionPage 
      offerId={offerId}
    />
  );
}

export default WeekTwoMain;